import { ConvertIdService } from './convert-id.service';
import { ConvertNameService } from './convert-name.service';
import { APIService } from './api.service';
import { TokenService } from './token.service';

export { ConvertIdService, ConvertNameService, APIService, TokenService };

export default [ConvertIdService, ConvertNameService, APIService, TokenService];
